import React, { useEffect, useRef } from 'react';

type SafeHTMLBlockProps = {
  text: string;
  containerClassname?: string;
};

const SafeHTMLBlock = ({ text = '', containerClassname= '' }: SafeHTMLBlockProps) => {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current) return;

    ref.current.innerHTML = text;

    const links = ref.current.querySelectorAll('a');

    links.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    });

    return () => {
      links.forEach((link) => {
        link.removeEventListener('click', (e) => e.stopPropagation());
      });
    };
  }, [text]);

  return <div ref={ref} className={containerClassname} />;
};

export default SafeHTMLBlock;
